import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Title from './Title';


interface HeaderProps {
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
    alignment?: 'start' | 'center' | 'end';
}

const Header: React.FC<HeaderProps> = ({ title, subtitle, children, alignment = 'start' }) => {
    return (
        <Box component='header' display="flex" justifyContent={children ? 'space-between' : alignment}
             alignItems={children ? 'center' : alignment} sx={{ mb: 3, mt: 1, ml: 4, mr: 3 }}>

            <Box sx={{ textAlign: alignment }}>
                <Title>{title}</Title>
                <Typography color="textSecondary" component="div">{subtitle}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 1 }}>
                {children}
            </Box>
        </Box>
    );
};

export default Header;